// ======== plugin import ========= //
import {
    useState, 
    useEffect, 
    useRef,
} from 'react'
import Swal from 'sweetalert2';
import axios from 'axios';
// ========= component import ======= //
import AddProduct from './component/AddProduct';
import ProductList from './component/ProductList';
import ProductUpdateDrawer from './component/ProductUpdateDrawer';
import SideDrawer from '../../../../../../../../component/common/SideDrawer';
const ProductSetup = (props) => {
    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');
    const formRef = useRef();
    const {
        formValidateError,
        formData,
    } = props;
    // -------- define all state ------- //
    const [ updateProductList , setUpdateProductList ] = useState([]);
    const [ productUpdateIndex, setProductUpdateIndex ] = useState(-1);
    const [ productList, setProductList ] = useState([]);
    const [ productUpdateDrawerIsOpen, setProductUpdateDrawerIsOpen] = useState(false);
    const [productStateIsChange, setProductStateIsChange] = useState(false);
    // ------------------------ Manage product data  ---------------- //
    const productSaveHandler = async (product) => {
        setProductStateIsChange(true)
        if(Object.keys(product).length > 0){
            let productSynonyms = []
            if(product.product_synonyms !== ''){
                productSynonyms = JSON.parse(product.product_synonyms)
            }
            const newProduct = {
                product_name: product.product_name,
                product_synonyms: productSynonyms,
            };
            let isProductDuplicate = false;
            if(formData['step3'].product_setup.product_name !== ''){
                isProductDuplicate = formData['step3'].product_setup.some(
                    (products) => products.product_name.trim() === product.product_name.trim()
                );
            }
            if( productUpdateIndex < 0 ){
                if (isProductDuplicate) {
                    await Swal.fire({
                        text: 'Duplicate product name cannot be added !',
                        icon: 'error',
                        showCancelButton: true,
                        showConfirmButton : false,
                        cancelButtonText: 'OK',
                    });
                    return;
                }
                setProductList((prevList) => [...prevList, newProduct]);
                props.onInputChange(
                    'step3',
                    'product_setup',
                    [
                        ...(Array.isArray(formData['step3'].product_setup) ? formData['step3'].product_setup : []),
                        newProduct
                    ]
                );
            }
            else{
                const updateProductState = [...formData['step3'].product_setup];
                if(updateProductState[productUpdateIndex].product_name !== newProduct.product_name){
                    if (isProductDuplicate) {
                        await Swal.fire({
                            text: 'Duplicate product name cannot be added !',
                            icon: 'error',
                            showCancelButton: true,
                            showConfirmButton : false,
                            cancelButtonText: 'OK',
                        });
                        return;
                    }
                }
                // ----- update product_features_association -------- //
                let old_product_name = updateProductState[productUpdateIndex].product_name;
                let new_product_name = newProduct.product_name;
                const productFeatureAddData = formData['step3'].product_features_association;
                if(Object.keys(productFeatureAddData).length > 0){
                    if (productFeatureAddData[old_product_name]) {
                        const updatedState = {
                            ...productFeatureAddData,
                            [new_product_name]: productFeatureAddData[old_product_name]
                        };
                        delete updatedState[old_product_name];
                        props.onInputChange('step3', 'product_features_association', updatedState);
                    }
                }
                // ------- update product_features_association_data ------ //
                const productFeatureAssData = formData['step3'].product_features_association_data;
                if(productFeatureAssData.length > 0){
                    var needArr = productFeatureAssData.map((item) => {
                        return {
                            ...item,
                            select_association: item.select_association.map((assoc) => {
                                return {
                                    label: assoc.label.replace(
                                        `Product: ${old_product_name},`,
                                        `Product: ${new_product_name},`
                                    ),
                                    value: assoc.value.replace(
                                        `Product: ${old_product_name},`,
                                        `Product: ${new_product_name},`
                                    ),
                                };
                            }),
                        };
                    });
                    props.onInputChange(
                        'step3',
                        'product_features_association_data',
                        needArr
                    );
                }
                // ------- update product state ------- //
                updateProductState[productUpdateIndex] = newProduct;
                setProductList(updateProductState);
                props.onInputChange(
                    'step3',
                    'product_setup',
                    updateProductState
                );
                setProductUpdateDrawerIsOpen(false);
                props.productSetupApiIsCall(true)
            }
            setProductUpdateIndex(-1)
        }
    }

    const productUpdateHandler = (index) => {
        setUpdateProductList([productList[index]])
        setProductUpdateIndex(index)
        setProductUpdateDrawerIsOpen(true)
    }

    const productDeleteHandler = (index) => {
        setProductStateIsChange(true)
        
       
        const updateProductList = [...productList];
        var productName = updateProductList[index].product_name;

        // ------- delete product features Association ---------- //
        const associationDataState = formData['step3'].product_features_association;
        if(
            Object.keys(associationDataState).length > 0 &&
            associationDataState.hasOwnProperty(productName)
        ) 
        {
            const newObj = Object.keys(associationDataState)
            .filter(key => key !== productName)
            .reduce((acc, key) => {
                acc[key] = associationDataState[key];
                return acc;
            }, {});
            props.onInputChange('step3', 'product_features_association', newObj);
        }

        // --------- delete product_feature_association_data ---------- //
        let pfAssData = formData['step3'].product_features_association_data;
        if( pfAssData.length > 0 ){
            const filterProductData = (data, productToRemove) => {
                return data
                .map((item) => ({
                ...item,
                select_association: item.select_association.filter(
                    (assoc) => !assoc.value.includes(`Product: ${productToRemove}`)
                ),
                }))
                .filter((item) => item.select_association.length > 0);
            };
            const pfAssDataUpdate =  filterProductData(pfAssData, productName);
            props.onInputChange('step3', 'product_features_association_data', pfAssDataUpdate);
        }
        // -------- delete product setup state ------- //
        updateProductList.splice(index, 1);
        setProductList(updateProductList);
        props.onInputChange(
            'step3',
            'product_setup',
            updateProductList
        );
        props.productSetupApiIsCall(true)
    }

    const productListOnDropHandler = (rearrangeProductData) => {
        setProductStateIsChange(true)
        setProductList(rearrangeProductData);
        props.onInputChange(
            'step3',
            'product_setup',
            rearrangeProductData
        );
    }

    useEffect(() => {
        if( formData['step3'].product_setup.length > 0 ){
            setProductStateIsChange(false)
            setProductList(formData['step3'].product_setup);
        }
    },[formData['step3']]);

    const drawerOnCloseHandler = (drawerName) => {
        const drawerMap = {
            product_setup_update_drawer: () => {
                setProductUpdateDrawerIsOpen(false); 
                setProductUpdateIndex(-1);
            },
        };
        if (drawerMap[drawerName]) {
            drawerMap[drawerName]();
        }
    }

    // ------ product setup api call -------- //
    useEffect(() => {
        const saveProductDetails = async () => {
            if(!productStateIsChange) return;
            const saveProductData = async () => {

                let product = [];

                if( productList.length > 0 ){
                    const indexedProduct = productList.map((product, index) => ({
                        ...product,
                        index,
                    }));
                    product = indexedProduct
                }
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                let productFormData = new FormData();
                productFormData.append("action_type", 'product_setup');
                productFormData.append("bot_id", formData.bot_id);
                productFormData.append("step", "step3");
                productFormData.append("data", JSON.stringify(product));
                productFormData.append("sass_id", localStorage.getItem('sass_id'));
                productFormData.append("user_type", localStorage.getItem('type'));
                productFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, productFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            productFormData = new FormData();
                            setProductStateIsChange(false)
                            formRef.current?.resetForm();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
            await saveProductData();
        }
        saveProductDetails()
    },[productList]);

    return (
        <>
            <div className="row border border-dashed border-gray-400 rounded p-5 mb-5">
                <a className="fw-bold text-gray-800 mb-2 fs-3">
                    Product Setup
                </a>
                <div className="col-md-12  mb-3">
                    <AddProduct
                        productSave = {productSaveHandler}
                        updateProductList = {updateProductList}
                        formValidateError = {formValidateError}
                        isInfoOpenHandler={props.isInfoOpenHandler}
                        ref={formRef}
                    />
                </div>
                <ProductList
                    productDataList = {productList}
                    productUpdateOnClick ={productUpdateHandler}
                    productDeleteOnClick = {productDeleteHandler}
                    productListOnDrop={productListOnDropHandler}
                />
            </div>
            <SideDrawer
                title={'Product Data Update'}
                width={600}
                open={productUpdateDrawerIsOpen}
                drawer_name={'product_setup_update_drawer'}
                placement={'right'}
                closable={false}
                drawerOnClose={drawerOnCloseHandler}
            >
                <ProductUpdateDrawer
                    productSave = {productSaveHandler}
                    updateProductList = {updateProductList}
                    formValidateError = {formValidateError}
                    ref={formRef}
                />
            </SideDrawer>
        </>
    )
}

export default ProductSetup
